import React from 'react';

export const Testimonials = () => {
  const testimonials = [
    {
      name: "Sarah M.",
      text: "I was drowning in debt until Tradeco helped me find a way out. Now I'm debt-free and living life on my terms.",
      savings: "R8,500 monthly savings"
    },
    {
      name: "John P.",
      text: "The legal team at Tradeco made the whole process smooth and stress-free. I couldn't be happier with the results.",
      savings: "R12,300 monthly savings"
    }
  ];

  return (
    <div className="py-16 bg-[#1A1F2C]/50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-white mb-12">
          Success Stories
        </h2>
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="p-6 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10">
              <p className="text-gray-300 mb-4">"{testimonial.text}"</p>
              <div className="flex justify-between items-center">
                <span className="font-semibold text-white">{testimonial.name}</span>
                <span className="text-primary">{testimonial.savings}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};